import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {HomePage} from '../pages/Home/HomePage'
import {TaskPage} from '../pages/task'
import {AssignTaskPage} from '../pages/task/assign-task'
import {BrowseTagPage} from '../pages/browse-tag'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {TestPage} from '../pages/test'
const PrivateRoutes = () => {
  const SuperAdminPage = lazy(() => import('../modules/company-group-admin/SuperAdminPage'))
  const RootAdminPage = lazy(() => import('../modules/super-admin/RootAdminPage'))
  const CompanyAdminPage = lazy(() => import('../modules/company-admin/CompanyAdminPage'))
  const RegisterPage = lazy(() => import('../modules/register/RegisterPage'))
  const ReportPage = lazy(() => import('../modules/report/ReportPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/home' />} />
        {/* Pages */}
        <Route path='home' element={<HomePage />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='tasks' element={<TaskPage />} />
        <Route path='tasks/assign-tag' element={<AssignTaskPage />} />
        <Route path='test' element={<TestPage />} />
        <Route path='browse-tag' element={<BrowseTagPage />} />

        {/* Lazy Modules */}
        <Route
          path='super-admin/*'
          element={
            <SuspensedView>
              <RootAdminPage />
            </SuspensedView>
          }
        />
        <Route
          path='company-group-admin/*'
          element={
            <SuspensedView>
              <SuperAdminPage />
            </SuspensedView>
          }
        />
        <Route
          path='company-admin/*'
          element={
            <SuspensedView>
              <CompanyAdminPage />
            </SuspensedView>
          }
        />
        <Route
          path='register/*'
          element={
            <SuspensedView>
              <RegisterPage />
            </SuspensedView>
          }
        />
        <Route
          path='report/*'
          element={
            <SuspensedView>
              <ReportPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
